import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Fold } from "../../common/game/GameControl";

const FoldButton = () => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  const FoldEventHandler = useCallback(
    (ev) => {
      console.log("event blablblbl:", currentIndex);
      // DC-FE-REMOVE-LOCAL-DISPATCH-002: Call API only, state updated via SignalR "Fold" event
      Fold(user.Id, gameState.GameCode, currentIndex);
    },
    [currentIndex, gameState, user]
  );
  if (gameState.CurrentId === user.Id && currentPlayer.PlayerCards.length > 0)
    return (
      <button className="btn Fold mt-1 me-1 me-md-0" onClick={FoldEventHandler}>
        Fold
      </button>
    );
  return <></>;
};

export default FoldButton;
